// @flow

import React from 'react';
import PropTypes from 'prop-types';
import ProjectContentDescription from '../ContentDescription';
import Tooltip from '../../../../../Resources/Common/Tooltip';

export default function Barriers(props) {
  const { proposalUid, blocked, hasRights } = props;
  return (
    <ProjectContentDescription
      title="Barrière à l'entrée"
      tooltip={Tooltip.ProjectOfferBarriers.description}
      proposalUid={proposalUid}
      hasRights={hasRights}
      blocked={blocked}
    />
  );
}

Barriers.propTypes = {
  hasRights: PropTypes.bool.isRequired,
  blocked: PropTypes.bool.isRequired,
  proposalUid: PropTypes.string
};

Barriers.defaultProps = {
  proposalUid: undefined
};
